import _ from 'lodash';
import React, { useContext } from 'react';
import { FormikContext, FormikProps, Form } from 'formik';
import { Buttons } from '../layout/Buttons';
import { Button } from '@mui/material';
import { useNavigate, createSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = styled(CircularProgress)`
  margin-right: 8px;
`;

const FormContainer = styled.div<{ isColumn?: boolean }>`
  ${p => p.isColumn ? `
  margin: 8px;
  display: flex;
  align-items: flex-end;
  padding: 1px 8px 0 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
  ` : ''}
`

interface FilterProps<T extends object> {
  formik: FormikProps<T>;
  children?: any;
  buttons?: any;
  page?: number;
  isChangeHash?: boolean;
  submitButtonText?: string;
  notChangeHistory?: boolean;
  isColumn?: boolean;
  notButton?: boolean;
}

type Filter = <T extends object>(
  props: FilterProps<T>
) => React.ReactElement<FilterProps<T>>;

export const Filter: Filter = (props) => {
  const navigate = useNavigate();

  const onClick = () => {
    props.isChangeHash !== false && changeHash()
  }

  const changeHash = () => {
    const values = props.formik.values

    if (!props.notChangeHistory) {
      navigate({
        pathname: location.pathname,
        search: _.size(values) ? `?${createSearchParams(_.omitBy({
          ...values,
          page: ''
         }, (v) => !v))}` : '',
      });
    }
  };

  return (
    <FormikContext.Provider value={props.formik}>
      <Form>
        <FormContainer isColumn={props.isColumn}>
          {props.children}
          {!props.notButton && (
            <Buttons isColumn={props.isColumn}>
              {props.buttons!}
              <Button
                variant="contained"
                type="submit"
                color="primary"
                onClick={onClick}
                disabled={props.formik.isSubmitting}
              >
                {props.formik.isSubmitting && <Loader size={16} />}
                {props.submitButtonText || '検索'}
              </Button>
            </Buttons>
          )}
        </FormContainer>
      </Form>
    </FormikContext.Provider>
  );
};
